module.exports = __webpack_public_path__ + "static/media/31-3.5be8d5fc.mp3";